import { dataArrowUUpLeft } from 'dls-icons-data'
import { createIcon } from '../common'

const IconArrowUUpLeft = /*#__PURE__*/createIcon(dataArrowUUpLeft)
export default IconArrowUUpLeft
